<template>
  <div>
    <private-layer>
      <template slot="box-title">
        <div class="title">报警</div>
      </template>
      <template slot="box-inner">
        <div class="content">
          <div class="tools clearfix">
            <div class="private-select no-bg">
              <el-select v-model="form.value" size="mini" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="chart" ref="chart"></div>
        </div>
      </template>
    </private-layer>
  </div>
</template>

<script>
import PrivateLayer from '../layer'
import { GetChartData } from '@/api/home'
export default {
  components: { PrivateLayer },
  data() {
    return {
      aArray: null,
      bArray: null,
      chart: {
        element: null,
        option: {
          grid: { containLabel: true },
          tooltip: { textStyle: { fontSize: 14 } }, // formatter: '{a} <br/>{c} 次'
          legend: { 
            orient: 'vertical',
            textStyle: { color: '#fff', fontSize: 12, padding: [0, 0, 0, 5] },
            bottom: 15, right: 0,
            itemWidth: 24, itemHeight: 12,
            itemGap: 3
          },
          dataset: {
            source: [
              // ['报警', '次数'],
              // ['翻车 ', 13],
              // ['超速', 55],
              // ['燃气报警', 8],
              // ['烟雾报警', 12],
              // ['撞车报警', 12],
            ]
          },
          series: [
            {
              type: 'pie',
              id: 'pie',
              selectedMode: 'single',
              radius: '80%',
              center: ['30%', '50%'],
              label: {
                  normal: {
                      position: 'inner',
                      formatter: '{d}%'
                  }
              },
            }
          ]
        }
      },
      form: {
        value: '30'
      },
      options: [
        { label: '月度', value: '30' }
      ]
    }
  },
  created() {
    this.initChartData()
  },
  mounted() {
    this.chartInit()
  },
  methods: {
    chartInit() {
      this.chart.element = this.$echarts.init(this.$refs.chart)
      this.setOption()
    },
    setOption() {
      this.chart.element.setOption(this.chart.option)
    },
    initChartData() {
      GetChartData().then(res => {
        if(res.dataList.length > 0){
          this.aArray = new Array();
          res.dataList.forEach((element,index) => {
            this.bArray = new Array();
            this.bArray.push(element.alarm_type)
            this.bArray.push(element.count)
            this.aArray.push(this.bArray)
          })
            this.chart.option.dataset.source.push(['报警', '次数'])
           this.chart.option.dataset.source = this.aArray
          this.setOption()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 2px 12px 2px;
  color: #fff;
  .tools {
    padding-bottom: 0px;
    .private-select {
      width: 100px;
      float: right;
    }
  }
  .chart {
    height: 160px;
  }
}
</style>